(function() {
    'use strict';

    angular.module('eclipseApp.myAccount').controller('registerCreditCardCtrl', ['$scope', '$filter', '$rootScope', '$stateParams', '$modal', '$http', 'httpService', '$state', 'uteEndpoint',
      'commonService', 'manageCreditCardService', 'prepaidUserInfoService', 'prepaidRegisteredCCInfoService', 'uteSemafoneService', 'util',
      function($scope,$filter, $rootScope, $stateParams, $modal, $http, httpService, $state, uteEndpoint,
               commonService, manageCreditCardService, prepaidUserInfoService, prepaidRegisteredCCInfoService, uteSemafoneService, util) {
        var selfCardType = '';
        var self = {};
        uteSemafoneService.clearData();

        $scope.$extend({
            accountDetails: commonService.accountDetails,
            selectedBAN: $stateParams.accountNumber,
            selectedCTN: $stateParams.subscriberNo,
            payment: {},
            today: new Date(),
            userFname: prepaidUserInfoService.getFirstName(),
            userLname: prepaidUserInfoService.getLastName(),
            billingAddress: prepaidUserInfoService.getBillingAddress(),
            registerFlag: prepaidRegisteredCCInfoService.getCreditCardRegistrationStatus(),
            //registerFlag:false,
            ccNum:$filter('maskCCNumber')(prepaidRegisteredCCInfoService.getTokenizedCCNumber()),
            creditCardExpiryMonth: manageCreditCardService.getExpiryMonth(),
            creditCardExpiryYear: manageCreditCardService.getExpiryYear(),
            payNow: {},
            ccType: null,
            reviewReady: false,
            isNotValidCard: false,
            creditCardFlowIndicator: null,
            showError: false,
            showRegister: false,
            showManage: false,
            showSemafone: false,
            editNumber: false,
            firstMonth: 1,
            setRange: function(min, max) {
                var months = [];
                for (var i = min; i <= max; i++) months.push(i);
                return months;
            },

            payNowRule: {
                ccNumber: {
                    pattern: '((([0-9]{4}[ -]?){4})|(([0-9]{4}[ -]?)([0-9]{6}[ -]?)([0-9]{5})))'
                },
                expMonth: {
                    type: 'number',
                    min: 1,
                    max: 12
                },
                expYear: {
                    type: 'number',
                    min: 2015,
                    max: 2025
                },
                cvv: {
                    type: 'text',
                    minlength: 3,
                    maxlength: 4,
                    pattern: '^[0-9]{3,4}$'
                },
                ccName: {
                    pattern: 'VISA|MASTER|AMEX'
                },
                ccTnc: {}
            },
            cvvValidation: function() {
                if (uteSemafoneService.getMaskedCardNumber() == null || uteSemafoneService.getMaskedCardNumber() == '') {
                } else {
                    if (uteSemafoneService.getCardScheme() == 'VISA' || uteSemafoneService.getCardScheme() == 'MASTERCARD') {
                        $scope.cvvMaxLength = 3;
                        $scope.cvvMinLength = 3;
                    }
                    if (uteSemafoneService.getCardScheme() == 'MASTERCARD') {
                        $scope.cvvMaxLength = 4;
                        $scope.cvvMinLength = 4;
                    }
                }

            },

            editCard: function() {
                $scope.showSemafone = true;
                $scope.editNumber = false;
            },

                processCCValidation: function(form) {
                util.validateFormOnSubmit(form);
                if (!form.$valid || ($scope.payNow.expYear == $scope.today.getFullYear() && $scope.payNow.expMonth <= $scope.today.getMonth())) {
                    if (uteSemafoneService.getMaskedCardNumber() == null || uteSemafoneService.getMaskedCardNumber() == '') {
                        $scope.isNotValidCard = true;
                    }
                    return;
                }

                if (uteSemafoneService.getCardScheme() == 'VISA') {
                    selfCardType = 'VISA';
                } else if (uteSemafoneService.getCardScheme() == 'AMEX') {
                    selfCardType = 'AMEX';
                } else if (uteSemafoneService.getCardScheme() == 'MASTERCARD') {
                    selfCardType = 'MASTERCARD';
                }

                var cvvLength = document.getElementById('cvv').value.length;
                $scope.maskedCardNumber = uteSemafoneService.getMaskedCardNumber();
                $scope.payment.maskedToken = uteSemafoneService.getToken();
                $scope.payment.ccType = uteSemafoneService.getCardScheme();

                if ($scope.payment.ccType == 'VISA') {
                    $scope.cardType = 'ute-creditcards visa';
                }
                if ($scope.payment.ccType == 'AMEX') {
                    $scope.cardType = 'ute-creditcards amex';
                }
                if ($scope.payment.ccType == 'MASTERCARD') {
                    $scope.cardType = 'ute-creditcards master';
                }

                if ($scope.payment.maskedToken == null || $scope.payment.maskedToken == '') {
                    $scope.isNotValidCard = true;
                    alert('The card number is invalid');
                } else {
                    console.log('$scope.payment ready', $scope.payment);

                }

                if ($scope.payNow.expMonth > 0 && $scope.payNow.expMonth < 10) {
                        self.expMonth = '0' + $scope.payNow.expMonth;
                      } else {
                        self.expMonth = $scope.payNow.expMonth;
                      }


                var promise = httpService.send(
                    'v1/wireless/prepaid/creditcard/register', // TODO : Need to change
                    {
                        'CreditCardInfo.ccType': $scope.payment.ccType,
                        'CreditCardInfo.ccNumber': $scope.payment.maskedToken,
                        'CreditCardInfo.ccExpiryMonth': self.expMonth,
                        'CreditCardInfo.ccExpiryYear': $scope.payNow.expYear,
                        'CreditCardInfo.securityCode': $scope.payNow.cvv,
                         ctn: prepaidUserInfoService.getCTN(),
                         accountNumber: prepaidUserInfoService.getBAN()
                    });

                promise.then(
                    function(result) {
                        if (result.data.error || result.data.status == 'Rejected') {
                            $scope.showError = true;
                        } else {
                        $scope.creditCardRegInfo = result.data;
                        manageCreditCardService.setCardStatus($scope.creditCardRegInfo.status);
                            $scope.retrieveCreditCardRegistrationInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN());
                        }
                    },
                    function(reason) {
                        $scope.showError = true;
                    }
                );

            },


            retrieveCreditCardRegistrationInfo: function(accountNumber, subscriberNumber) {
                var promise = httpService.send(
                    'v1/wireless/prepaid/creditcard/retrieve/ccinfo', // TODO : Need to change
                    {
                        accountNumber: accountNumber,
                        ctn: subscriberNumber
                    });

                promise.then(
                    function(result) {
                        if (result.data.error || result.data.status == 'Failed') {
                            $scope.showError = true;
                        } else {
                            $scope.creditCardRegistrationInfo = result.data;
                            prepaidRegisteredCCInfoService.setCreditCardRegistrationStatus($scope.creditCardRegistrationInfo.registrationStatus);
                            if (prepaidRegisteredCCInfoService.getCreditCardRegistrationStatus()) {
                                //prepaidRegisteredCCInfoService.setCardScheme($scope.creditCardRegistrationInfo.creditCardInfo.cardType);
                                prepaidRegisteredCCInfoService.setCreditCardRegistrationStatus($scope.creditCardRegistrationInfo.registrationStatus);
                                prepaidRegisteredCCInfoService.setTokenizedCCNumber($scope.creditCardRegistrationInfo.creditCardInfo.creditCardNo);
                                prepaidRegisteredCCInfoService.setMonth($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                                prepaidRegisteredCCInfoService.setYear($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);

                            }
                            $state.go('myAccount.registerCreditCardConfirm');
                        }
                    },
                    function(reason) {
                        $scope.showError = true;
                    }
                );
            },


            manageCCvalidation: function(form) {
                util.validateFormOnSubmit(form);
                if (!form.$valid || ($scope.payNow.expYear == $scope.today.getFullYear() && $scope.payNow.expMonth <= $scope.today.getMonth())) {
                    if (uteSemafoneService.getMaskedCardNumber() == null || uteSemafoneService.getMaskedCardNumber() == '') {
                        $scope.isNotValidCard = true;
                    }
                    return;
                }

                if (uteSemafoneService.getCardScheme() == 'VISA') {
                    selfCardType = 'VISA';
                } else if (uteSemafoneService.getCardScheme() == 'AMEX') {
                    selfCardType = 'AMEX';
                } else if (uteSemafoneService.getCardScheme() == 'MASTERCARD') {
                    selfCardType = 'MASTERCARD';
                }

                var cvvLength = document.getElementById('cvv').value.length;
                $scope.maskedCardNumber = uteSemafoneService.getMaskedCardNumber();
                $scope.payment.maskedToken = uteSemafoneService.getToken();
                $scope.payment.ccType = uteSemafoneService.getCardScheme();

                if ($scope.payment.ccType == 'VISA') {
                    $scope.cardType = 'ute-creditcards visa';
                }
                if ($scope.payment.ccType == 'AMEX') {
                    $scope.cardType = 'ute-creditcards amex';
                }
                if ($scope.payment.ccType == 'MASTERCARD') {
                    $scope.cardType = 'ute-creditcards master';
                }

                if ($scope.payment.maskedToken == null || $scope.payment.maskedToken == '') {
                    $scope.isNotValidCard = true;
                    alert('The card number is invalid');
                } else {
                    console.log('$scope.payment ready', $scope.payment);

                }

                 if ($scope.payNow.expMonth > 0 && $scope.payNow.expMonth < 10) {
                                        self.expMonth = '0' + $scope.payNow.expMonth;
                                      } else {
                                        self.expMonth = $scope.payNow.expMonth;
                                      }


                var promise = httpService.send(
                    'v1/wireless/prepaid/creditcard/change', // TODO : Need to change
                    {
                        'CreditCardInfo.ccType': $scope.payment.ccType,
                        'CreditCardInfo.ccNumber': $scope.payment.maskedToken,
                        'CreditCardInfo.ccExpiryMonth': self.expMonth,
                        'CreditCardInfo.ccExpiryYear': $scope.payNow.expYear,
                        'CreditCardInfo.securityCode': $scope.payNow.cvv,
                        ctn: prepaidUserInfoService.getCTN(),
                        accountNumber: prepaidUserInfoService.getBAN()
                    });

                promise.then(
                    function(result) {
                        if (result.data.error || result.data.status == 'Rejected') {
                            $scope.showError = true;
                        } else {
                            var promise = httpService.send(
                                'v1/wireless/prepaid/creditcard/retrieve/ccinfo', // TODO : Need to change
                                {
                                    accountNumber: prepaidUserInfoService.getBAN(),
                                    ctn: prepaidUserInfoService.getCTN()
                                });

                            promise.then(
                                function(result) {
                                    if (result.data.error || result.data.status == 'Failed') {
                                        $scope.showError = true;
                                    } else {
                                        $scope.retrieveCreditCardRegistrationInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN());
                                    }
                                },
                                function(reason) {
                                    alert('error');
                                    $scope.showError = true;
                                }
                            );
                        }
                    },
                    function(reason) {
                        $scope.showError = true;
                    }
                );

            }


        });


        if ($scope.registerFlag == false) {
            $scope.creditCardFlowIndicator = 'REGISTERCC';
            $scope.showRegister = true;
            $scope.showManage = false;
            $scope.showSemafone = true;
            $scope.editNumber = false;

        } else if ($scope.registerFlag == true) {
            $scope.creditCardFlowIndicator = 'MANAGECC';
            $scope.showRegister = false;
            $scope.showManage = true;
            $scope.showSemafone = false;
            $scope.editNumber = true;
        } else {
            $scope.showError = true;
            $scope.showSemafone = true;
        }

        manageCreditCardService.setCreditCardFlowIndicator($scope.creditCardFlowIndicator);
        if ($scope.billingAddress.addressLine2 != 'null') {
            $scope.addressLine2 = true;
        }




    }]);

})();
